export default __webpack_public_path__ + "static/media/placeholder_business05-jp-mobile.69a7e984.png";